import { render } from "./BanksView.vue?vue&type=template&id=5acd9361"
import script from "./BanksView.vue?vue&type=script&lang=js"
export * from "./BanksView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__